<template>
  <b-container class="p-3" fluid>
    <portal to="project-action-bar">
      <b-button variant="success" class="mr-2" :disabled="!isSubmitable && !isSaving" @click="submit">
        <font-awesome-icon v-if="!isSaving" icon="save" />
        <b-spinner v-else class="mr-1" small />
        บันทึก
      </b-button>
      <b-button variant="outline-secondary" @click="discardEdit({ name: 'projects.show.proposal.basic', params: $route.params })">
        <font-awesome-icon icon="times" />ย้อนกลับ
      </b-button>
    </portal>

    <loading-spinner v-if="isLoading" text="กำลังโหลด..." />

    <b-row v-else>
      <b-col>
        <create-form-basic-info
          ref="form"
          v-model="form"
          class="mb-4"
          @ready="state => isSubmitable = state"
          @dirty="state => isDirty = state"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CreateFormBasicInfo from '@/components/project/create/CreateFormBasicInfo'
import projectEditMixins from '@/mixins/projectEditMixins'
import _ from 'lodash'

export default {
  components: {
    CreateFormBasicInfo
  },
  mixins: [ projectEditMixins ],
  created () {
    this.$store.dispatch('project/loadBasicInfo', this.$route.params.id).then(() => {
      this.form = _.cloneDeep(_.pick(this.project, [
        'id',
        'name',
        'acYearId',
        'advisor',
        'group',
        'coordinators',
        'personInCharge',
        'background',
        'objectives',
        'venue',
        'timeframeRaw',
        'attendee'
      ]))

      // Parse Carbon timestamp to JS Date object
      if (this.form.timeframeRaw) {
        this.form.timeframeRaw.start = new Date(this.form.timeframeRaw.start)
        this.form.timeframeRaw.end = new Date(this.form.timeframeRaw.end)
      }

      this.isLoading = false
    })
  },
  methods: {
    async submit () {
      if (!this.$refs.form.validate()) {
        this.isSubmitable = false
        this.flashValidationErrorToast()
        return
      }

      try {
        await this.$store.dispatch('project/patchProposal', this.form)
        await this.flashSaveSuccessToast()
        this.$router.push({ name: 'projects.show.proposal.basic', params: this.$route.params })
      } catch {
        this.flashValidationErrorToast()
      }
    }
  }
}
</script>
